<!-- #region Title -->
<mat-toolbar *ngIf="header" dense>{{header}}</mat-toolbar>
<!-- #endregion-->

<div layout="column" layout-gt-sm="row" [formGroup]="form" [ngClass]="{'has-header': header}" *ngIf="form" flex>
	<!-- #region Net -->
	<mat-form-field flex layout-margin appearance="outline">
		<mat-label i18n>Net</mat-label>
		<input matInput type="number" formControlName="net" [readonly]="readonly" [min]="min">
		<mat-error *ngFor="let errorMessage of form.controls.net['errorMessages']">{{errorMessage}}</mat-error>
	</mat-form-field>
	<!-- #endregion -->

	<!-- #region Tax -->
	<mat-form-field flex layout-margin appearance="outline" *ngIf="!options?.hideTax">
		<mat-label i18n>Tax</mat-label>
		<input matInput type="number" formControlName="tax" [readonly]="readonly" [min]="min">
		<mat-error *ngFor="let errorMessage of form.controls.tax['errorMessages']">{{errorMessage}}</mat-error>
	</mat-form-field>
	<!-- #endregion -->

	<!-- #region Gross -->
	<mat-form-field flex layout-margin appearance="outline">
		<mat-label i18n>Gross</mat-label>
		<input matInput type="number" formControlName="gross" [readonly]="readonly" [min]="min">
		<mat-error *ngFor="let errorMessage of form.controls.gross['errorMessages']">{{errorMessage}}</mat-error>
	</mat-form-field>
	<!-- #endregion -->

	<!-- #region TaxAmount -->
	<mat-form-field flex layout-margin appearance="outline">
		<mat-label i18n>Tax amount</mat-label>
		<input matInput type="number" formControlName="taxAmount" [readonly]="readonly" [min]="min">
		<mat-error *ngFor="let errorMessage of form.controls.taxAmount['errorMessages']">{{errorMessage}}</mat-error>
	</mat-form-field>
	<!-- #endregion -->
</div>